import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "@tanstack/react-router";
import { setSessionExpiredHandler } from "./lib/apiClient.js";
import { rum } from "./perf/rum.js";
import { router } from "./router.js";
import { applyDensity, applyDirection, applyTheme, readStoredDensity, readStoredTheme } from "./store/uiStore.js";
import "./styles/index.css";

const container = document.getElementById("root");
if (container === null) {
  throw new Error("#root 容器缺失：apps/web/index.html 的 <div id=\"root\"> 被改动了");
}

// 401（会话失效）→ apiClient 清空内存会话后调用这里：走 SPA 路由跳登录并带上回跳地址，
// 避免整页刷新（整页刷新会丢掉当前页面的筛选与滚动位置）。
setSessionExpiredHandler(() => {
  if (window.location.pathname === "/login") return;
  const redirect = `${window.location.pathname}${window.location.search}`;
  void router.navigate({ to: "/login", search: { redirect }, replace: true });
});

// 首屏前再应用一次（index.html 的引导脚本已经写过，这里保证 SSR/热更新场景一致）。
// 方向（polaris = console 定稿语言）是无条件写死的：它没有用户偏好，只有一套。
applyTheme(readStoredTheme());
applyDensity(readStoredDensity());
applyDirection();

// RUM 采集：LCP / CLS / INP 近似 / 长任务；结果在右下角性能面板可见
rum.start();

// 无人值守脚本用的稳定入口（跨路由存在，不会被页面卸载清掉）
window.__AMS_RUM__ = () => rum.snapshot();

// 「跟随系统」时，系统主题切换要实时生效（不需要刷新）
const media = window.matchMedia("(prefers-color-scheme: dark)");
media.addEventListener("change", () => {
  if (readStoredTheme() === "system") applyTheme("system");
});

createRoot(container).render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>,
);
